// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            width: 543px;
            height: 543px;
            margin-bottom: 20px;
            margin-top: 0;
            ${xScreen("lte", "md")} {
                width: 358px;
                height: 358px;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
            @media print {
                width: 100%;
                height: 100%;
            }
        `,
    },
    img: {
        height: 543,
        width: 543,
        css: css`
            width: 100%;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        `,
        ...{ disableLazyLoading: true },
    },
};
primaryImageStyles.maximizeButton = {
    css: css`
        height: 24px;
        width: 24px;
        border-radius: 4px;
        position: absolute;
        min-height: unset;
        top: 12px;
        left: 12px;
        border: none;
        padding: 0;
        &,
        &:hover,
        &:focus {
            background-color: ${color("common.ui2")};
        }
        ${IconWrapper}, svg {
            width: 16px;
            height: 16px;
            font-weight: normal;
            color: ${color("common.ui5")};
        }
    `,
};

primaryImageStyles.primaryImageWrapper = {
    css: css`
        position: relative;
    `,
};

primaryImageStyles.fullPrimaryImageModal = {
    mergeCss: true,
    sizeVariant: "large",
    size: 1230,
    cssOverrides: {
        modalTitle: css`
            &&&& {
                padding: 4px 0 0;
                border: none;
            }
        `,
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            border-radius: 4px;
            width: 100%;
            max-width: initial;
        `,
        modalContent: css`
            &&&& {
                padding: 20px 154px;
                transition: none;
                ${xScreen("lte", "sm")} {
                    padding: 10px 20px;
                }
            }
            background: ${color("common.ui1")};
            overflow-y: auto;
            text-align: center;
        `,
    },
    closeButtonProps: {
        size: 16,
        buttonType: "solid",
        sizeVariant: "small",
        shape: "pill",
        variant: "primary",
        color: "common.ui1",
        css: css`
            position: absolute;
            padding: 0;
            top: 12px;
            right: 12px;
            border: 0;

            &:hover,
            &:focus {
                background: none;
                border: 0;
                opacity: 0.33;
            }
        `,
    },
    closeButtonIconProps: {
        size: 16,
        css: css`
            &${IconWrapper}, svg {
                width: 10px;
                height: 16px;
            }
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    centeringWrapper: {
        css: css`
            margin: 0;
            position: relative;
        `,
    },
    img: {
        css: css`
            width: auto;
            max-height: 70vh;
        `,
    },
};

primaryImageStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

primaryImageStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
    `,
};

primaryImageStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: 25%;
    `,
};

primaryImageStyles.badgeText = {
    weight: "bold",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
    `,
};
